import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import getClassNames from 'src/common/utils/getClassNames';
import styles from './SnoozeFooter.module.scss';

type FooterProps = {
  children: ReactNode;
  separator?: boolean;
};

const Footer: FC<FooterProps> = ({
  children,
  separator,
}) => (
  <div
    className={getClassNames(
      styles,
      'buttonGroup',
      classNames({ separator }),
    )}
  >
    {children}
  </div>
);

export default Footer;
